import React, { useEffect } from "react";
import img from "../images/me1.png";
import img1 from "../images/me2.png";
import "./About.css";
import Footer from "../Components/Footer";
import Aos from "aos";
import { SiFiverr, SiUpwork } from "react-icons/si";
import { IoLogoWhatsapp } from "react-icons/io";
import { AiFillLinkedin } from "react-icons/ai";
import { FaFacebookF } from "react-icons/fa";

import Skills from "./Skills";
import Prices from "./Prices";
import Typical from "react-typical";

const Aboutus = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  return (
    <div className="container-fluid">
      <div className="main">
        <div className="header">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-12 icons-col">
                <div className="header__content">
                  <div className="header__section " data-aos="fade-right">
                    <div className="icons-style">
                      <a
                        href="https://www.upwork.com/workwith/avinashkumar3"
                        target="_blank"
                      >
                        {" "}
                        <SiUpwork className="fiverr" />
                      </a>
                      <a
                        href="https://www.fiverr.com/share/yELXYZ"
                        target="_blank"
                      >
                        <SiFiverr className="fiverr" />
                      </a>
                      <a href="https://wa.link/xoepwv" target="_blank">
                        <IoLogoWhatsapp className="fiverr" />
                      </a>
                      <a
                        href="https://www.linkedin.com/in/avinash-kumar-8329921bb/"
                        target="_blank"
                      >
                        <AiFillLinkedin className="fiverr" />
                      </a>
                      <a
                        href="https://www.facebook.com/Avinash.kumar.luhana/"
                        target="_blank"
                      >
                        <FaFacebookF className="fiverr" />
                      </a>
                    </div>

                    <Typical
                      steps={["Hello World!", 500, "I am Avinash Kumar", 1000]}
                      loop={Infinity}
                      wrapper="p"
                    />
                    {/* <h1>I am Avinash kumar</h1> */}
                    <p>Web developer having Frontend Skills</p>
                    <div className="banner-buttons">
                      <a className="btn btn-outline">My protofolio</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 image-col">
                <img
                  data-aos="fade-left"
                  src={img}
                  alt="image"
                  className="personal-image"
                />
              </div>
            </div>
          </div>
        </div>
        <Skills />

        <div className="aboutme">
          <div className="aboutme-contents">
            <h1 className="main-heading">About me</h1>
            <div className="border-about"> </div>
            <div className="row">
              <div
                className="col-lg-6 col-md-6 col-sm-12 about-col"
                data-aos="fade-up"
                data-aos-duration="3000"
              >
                <div className="image-column">
                  <img src={img1} className="about-image" />
                </div>
              </div>
              <div
                className="col-lg-6 col-md-6 col-md-12 about-column"
                data-aos="fade-down"
                data-aos-easing="linear"
                data-aos-duration="1500"
              >
                <h1 classNmae="about-heading">Hello World!</h1>
                <div className="about-p">
                  <p className="about-text">
                    I am a software engineer with 3+ years of experience in
                    programming and coding, I have command in multiple
                    programming languages and I am a self-taught computer
                    science Enthusiast. I have worked with many local
                    freelancers and some small startups developing their
                    projects.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Prices section */}

        <Prices />
        <Footer />
      </div>
    </div>
  );
};

export default Aboutus;
